export const sharedCalculatorNav = {
  calculatorSettings: 'Calculator settings',
  calculatorSettingsDestinations: 'Destinations',
  calculatorSettingsVehicleTypes: 'Vehicle types',
  calculatorSettingsEngineTypes: 'Engine types',
};

export const sharedCalculatorTranslations = {
  toolsPage: {
    title: 'Tools & Calculators',
    subtitle: 'Useful tools and calculators for managing your auction business',
    vehicleImportCalculator: 'Vehicle Import Calculator',
    vehicleImportDesc:
      'Calculate total import costs for vehicles from IAAI, Copart, and Manheim auctions. Supports Armenia and Georgia with country-specific tax calculations and user discounts.',
    georgianCustomsCalculator: 'Georgian Customs Calculator',
    georgianCustomsDesc:
      'Calculate Georgian customs fees for vehicle registration including excise tax, import tax, and registration fees.',
    comingSoon: 'Coming Soon',
    profitCalculator: 'Profit Calculator',
    profitCalculatorDesc: 'Calculate profit margins and ROI for auction purchases',
    shippingCalculator: 'Shipping Calculator',
    shippingCalculatorDesc: 'Estimate shipping costs from auction to your location',
  },

  toolsVehicleImport: {
    title: 'Vehicle Import Cost Calculator',
    chipGeorgia: 'Georgia',
    chipArmenia: 'Armenia',
    countryRequired: 'Country',
    countryArmenia: 'Armenia',
    countryGeorgia: 'Georgia',
    destination: 'Destination',
    destinationPoti: 'Poti',
    destinationBatumi: 'Batumi',
    resultDestinationSurcharge: 'Destination surcharge',
    auctionRequired: 'Auction',
    vehiclePriceUsd: 'Vehicle Price (USD)',
    yearRequired: 'Year',
    locationOptional: 'Location (optional)',
    searchLocationPlaceholder: 'Search location...',
    engineTypeRequired: 'Engine Type',
    fuelGasoline: 'Gasoline',
    fuelDiesel: 'Diesel',
    fuelHybrid: 'Hybrid',
    fuelElectric: 'Electric',
    engineVolumeCc: 'Engine Volume (cc)',
    vehicleTypeRequired: 'Vehicle Type',
    scaleSedan: 'Sedan',
    scaleTruck: 'Truck',
    scaleMotorcycle: 'Motorcycle',
    scaleQuadBike: 'Quad Bike',
    scaleSnowmobile: 'Snowmobile',
    userTypeRequired: 'User Type',
    userCompany: 'Company',
    userIndividual: 'Individual',
    highClearanceVehicle: 'High Clearance Vehicle',
    withoutVatAah: 'Without VAT (AAH)',
    hybridNash: 'Hybrid: ICE power exceeds max 30-min electric motor power',
    onePointTwoCoefficient: '1.2 coefficient (commission)',
    includeInsurance: 'Include Insurance',
    customTransportPrice: 'Custom Transport Price (USD)',
    calculating: 'Calculating...',
    geoChecking: 'Checking location...',
    calculate: 'Calculate',
    resultsTitle: 'Calculation Results',
    resultsInputSummary: 'Your inputs (for reference)',
    calculationTimestamp: 'Calculated at',
    exchangeRatesPending:
      'Exchange rates (USD, EUR, AMD) will appear in the results when the calculation provides them.',
    previewFobEstimate: 'Auction Fee estimate (live)',
    previewTransportEstimate: 'Transport estimate (live)',
    exchangeRatesAtCalculation: 'Exchange rates at calculation time (USD / EUR / AMD)',
    calculationTimestampUtc: 'Time (UTC)',
    monthDayHint: 'Month / Day',
    vehicleMonth: 'Month (first registration)',
    vehicleDay: 'Day (first registration)',
    armeniaDateSection: 'First registration date (Armenia)',
    armeniaExtraSection: 'Additional options (Armenia)',
    resultVehiclePrice: 'Vehicle Price',
    resultFob: 'Auction Fee',
    resultTransport: 'Transport',
    resultTransportListPrice: 'Transport (list price)',
    resultDiscountAmount: 'Dealer discount',
    resultInsurance: 'Insurance',
    resultBnph: 'Environmental tax (required)',
    resultCommission: 'Commission',
    resultImportTax: 'Import Tax',
    resultVatAah: 'VAT (AAH)',
    resultDiscount: 'Discount ({percent}%)',
    resultAppliedTo: 'Applied to',
    discountTargetTransport: 'Transport',
    resultTotalCost: 'Total Cost',
    calculationInProgress: '(Calculation in progress...)',
    transportWasStrikethrough: '(was {amount})',
    errorInvalidApi: 'The calculator returned an incomplete result. Please try again.',
    errorCalculationFailed: 'Calculation failed. Please check your inputs and try again.',
  },

  toolsGeorgianCustoms: {
    title: 'Georgian Car Customs Calculator',
    liveChip: 'LIVE',
    vehicleType: 'Vehicle Type',
    carType: 'Car Type',
    wheelPosition: 'Wheel Position',
    registrationType: 'Registration Type',
    typeCar: 'Car',
    typeMotorcycle: 'Motorcycle',
    carPetrolDiesel: 'Petrol/Diesel',
    carElectric: 'Electric',
    carHybrid: 'Hybrid',
    wheelLeft: 'Left',
    wheelRight: 'Right',
    regSingle: 'Single',
    regDouble: 'Double',
    engineVolumeCc: '(CC)',
    engineVolumeLiters: '(Liters)',
    engineVolumeLabel: 'Engine Volume',
    yearOfManufacture: 'Year of Manufacture',
    totalRegistrationCost: 'Total Registration Cost',
    vehicleAgeLabel: 'Vehicle Age',
    yearsSuffix: 'years',
    engineLabel: 'Engine',
    exciseRateLabel: 'Excise Rate',
    typeShort: 'Type',
    wheelShort: 'Wheel',
    registrationShort: 'Registration',
    exciseTax: 'Excise Tax',
    customsServiceTax: 'Customs Service Tax',
    registration: 'Registration',
    importTax: 'Import Tax',
    expertAssessment: 'Expert Assessment',
    customsDeclaration: 'Customs Declaration',
    internalTransit: 'Internal Transit (up to 60 days)',
  },

  calculatorDestinationsPage: {
    title: 'Georgia calculator - destinations',
    subtitle: 'Set extra port fees in USD. They are added to Georgia import estimates for each destination.',
    addDestination: 'Add destination',
    colSlug: 'ID',
    colLabel: 'Label',
    slugFormatHint: 'Use letters, numbers, and hyphens only (e.g. poti, batumi-port).',
    colPriceUsd: 'Price (USD)',
    colSort: 'Sort',
    loadError: 'Failed to load destinations',
    saveError: 'Failed to save destination',
    disabledOk: 'Destination removed from calculator (disabled)',
    removedOk: 'Destination deleted permanently',
    confirmRemoveTitle: 'Delete destination permanently?',
    confirmRemoveBody:
      'The destination {slug} will be removed for good. It will no longer appear in the import calculator or in this list. This cannot be undone.',
    confirmRemoveAction: 'Delete permanently',
    inactive: 'Disabled',
    activeLabel: 'Active',
    activeInCalculator: 'Active in calculator',
  },

  calculatorVehicleTypesPage: {
    title: 'Georgia calculator - vehicle types',
    subtitle:
      'Set fee (USD) added to US auction transport per vehicle category. The import calculator uses these values for Georgia.',
    addType: 'Add vehicle type',
    colId: 'Id',
    colName: 'Name',
    colPrice: 'Price',
    colCreatedAt: 'createdAt',
    colSlug: 'ID',
    colLabel: 'Label',
    slugFormatHint: 'Use letters, numbers, and hyphens only (e.g. sedan, custom-van).',
    colFeeUsd: 'Fee (USD)',
    colSort: 'Sort',
    emptyStateTitle: 'No vehicle types yet',
    emptyStateBody:
      'Add the categories and fees for Georgia import estimates. The calculator can show placeholder options until you add types here. Use the button above to create your first entry.',
    loadError: 'Failed to load vehicle types',
    saveError: 'Failed to save vehicle type',
    disabledOk: 'Vehicle type removed from calculator (disabled)',
    removedOk: 'Vehicle type deleted permanently',
    confirmRemoveTitle: 'Delete vehicle type permanently?',
    confirmRemoveBody:
      'The vehicle type {slug} will be removed for good. It will no longer appear in the import calculator or in this list. This cannot be undone.',
    confirmRemoveAction: 'Delete permanently',
    inactive: 'Disabled',
    activeLabel: 'Active',
    activeInCalculator: 'Active in calculator',
  },

  calculatorEngineTypesPage: {
    title: 'Georgia calculator - engine types',
    subtitle:
      'Set optional fee (USD) added to US auction transport per engine category. The import calculator uses these values for Georgia.',
    addType: 'Add engine type',
    colId: 'Id',
    colName: 'Name',
    colPrice: 'Price',
    colCreatedAt: 'createdAt',
    colSlug: 'ID',
    colLabel: 'Label',
    slugFormatHint: 'Use letters, numbers, and hyphens only (e.g. gasoline, plug-in-hybrid).',
    colFeeUsd: 'Fee (USD)',
    colSort: 'Sort',
    emptyStateTitle: 'No engine types yet',
    emptyStateBody:
      'Add the categories and optional fees for Georgia import estimates. The calculator can show placeholder options until you add types here. Use the button above to create your first entry.',
    loadError: 'Failed to load engine types',
    saveError: 'Failed to save engine type',
    disabledOk: 'Engine type removed from calculator (disabled)',
    removedOk: 'Engine type deleted permanently',
    confirmRemoveTitle: 'Delete engine type permanently?',
    confirmRemoveBody:
      'The engine type {slug} will be removed for good. It will no longer appear in the import calculator or in this list. This cannot be undone.',
    confirmRemoveAction: 'Delete permanently',
    inactive: 'Disabled',
    activeLabel: 'Active',
    activeInCalculator: 'Active in calculator',
  },

  auctionFeesPage: {
    fetchFailed: 'Failed to fetch fees',
    fetchError: 'Error fetching auction fees',
    deleted: 'Fee deleted successfully',
    deleteFailed: 'Failed to delete fee',
    deleteError: 'Error deleting fee',
    subtitle: 'Manage auction fees for Armenia and Georgia',
    addNewFee: 'Add New Fee',
    totalFees: 'Total Fees',
    allCountries: 'All Countries',
    armenia: 'Armenia',
    georgia: 'Georgia',
    currentView: 'Current View',
    tabArmenia: 'Armenia',
    tabGeorgia: 'Georgia',
    priceFrom: 'Price From *',
    priceTo: 'Price To * (0 = unlimited)',
    biddingFee: 'Bidding Fee',
    gateFee: 'Gate Fee',
    virtualBidFee: 'Virtual Bid Fee',
    brokerFee: 'Broker Fee',
    percentLabel: 'Percent (%)',
    percentColumn: 'Percent',
    isPercentBased: 'Is Percent Based',
    editFee: 'Edit Auction Fee',
    addFee: 'Add New Auction Fee',
    noFeesFor: 'No fees found for',
    typePercent: 'Percent',
    typeFixed: 'Fixed',
    feeType: 'Type',
    virtualBidShort: 'Virtual Bid',
    priceFromCol: 'Price From',
    priceToCol: 'Price To',
    confirmDeleteTitle: 'Confirm Delete',
    confirmDeleteBody: 'Are you sure you want to delete fee ID',
    feeUpdated: 'Fee updated successfully',
    feeCreated: 'Fee created successfully',
    saveFailed: 'Failed to save fee',
    saveError: 'Error saving fee',
  },
};
